import { RouteUrlList } from '@/libs/RouteList';
const ConfirmServiceAlert = [
    'POST',
    RouteUrlList.API_ConfirmServiceAlert.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: ''
    }
];
export default ConfirmServiceAlert;
